/**
 * ============================================================================
 * TRANSIENT: Appointment Config Page (appointment-config-page)
 * Type: poc
 * Amplitude key: none
 * End date: 2026-12-31
 * PR: #TODO_AFTER_PR_CREATION_appointment-config-page
 * ============================================================================
 */

import { Box, Button, Typography } from '@evaneos/b2b-ui';

type Props = {
    onConnect: () => void;
};

export const AppointmentDisconnectedStatePartial = ({ onConnect }: Props): JSX.Element => (
    <Box
        data-spec-id="agenda-disconnected-state"
        sx={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
            height: '100%',
            gap: 2,
            p: 4,
        }}
    >
        <Typography variant="h5" sx={{ fontWeight: 700 }}>
            {/* @todo translate: agenda.disconnected.title */}
            Activez la prise de RDV intégrée à Request Manager
        </Typography>
        <Typography
            variant="body2"
            sx={{ color: 'text.secondary', maxWidth: 480, textAlign: 'center' }}
        >
            {/* @todo translate: agenda.disconnected.description */}
            Connectez votre Google Agenda pour proposer des créneaux à vos voyageurs et synchroniser
            vos rendez-vous automatiquement.
        </Typography>
        <Button data-spec-id="agenda-connect-google-button" variant="contained" onClick={onConnect}>
            {/* @todo translate: agenda.connect.google */}
            Connecter Google Agenda
        </Button>
    </Box>
);
